// extracted by mini-css-extract-plugin
export default {"container":"styles_container__N-y53","containerNotActive":"styles_containerNotActive__KHUF3"};